import { fetchGet } from "@/lib/services";

export async function getSubscriptionSummary(branchCode?: string) {
  const url = branchCode
    ? `/subscriptiondata/?Branch_Code=${branchCode}`
    : `/subscriptiondata/`;
  return await fetchGet(url);
}

export async function getSubscriptionDetail(branchCode?: string) {
  const url = branchCode
    ? `/subscriptiondata/?Branch_Code=${branchCode}&subscriptiondata=true`
    : `/subscriptiondata/?subscriptiondata=true`;
  return await fetchGet(url);
}
